import React from 'react';
import { useTransition } from './TransitionContext';
import './TransitionOverlay.css';

// トランジションオーバーレイコンポーネント
const TransitionOverlay: React.FC = () => {
  const { transitionState, isTransitioning } = useTransition();

  // トランジション中でなければ何も表示しない
  if (!isTransitioning) {
    return null;
  }

  return (
    <div 
      className={`transition-overlay ${transitionState}`}
      style={{
        // z-indexを最高レベルに設定
        zIndex: 99,
        // ポインターイベントを無効化（アニメーション中の操作防止）
        pointerEvents: transitionState === 'expanding' ? 'all' : 'none'
      }}
    />
  );
};

export default TransitionOverlay;